<div [hidden]="showSpinner">
  <div [hidden]="showEmptyReportMsg">
    @for(question of questionListResponsponse.oowQuestion; track index; let index = $index; let first = $first){
    <fieldset [class.bl-margin-top--32]="!first">
      <legend class="bl-label bl-font-weight--800 bl-required" [attr.aria-describedby]="'desc-' + question.relativeOrder">
        {{ question.questionText }}
      </legend>
      <div>
        <div class="bl-check-wrap">
          @for(questionChoice of question.questionChoices; track optionIndex; let optionIndex = $index){
          <div class="bl-margin-top--8"
            [ngClass]="{ 'bl-validation-error': !question.answer && (pageSubmitted$ | async) }">
            <!-- [name] and [attr.name] are needed for Angular grouping logic -->
            <input type="radio" (change)="preciseIdAnsersSelection()" [id]="'question-'+index+'-choice-'+optionIndex"
              [(ngModel)]="questionListResponsponse.oowQuestion[index].answer" [value]="questionChoice.questionChoiceId"
              [name]="'question-'+index" [attr.name]="'question-'+index"
              [attr.data-automation-id]="'questionChoice' + questionChoice.questionChoiceId" required #radioGroup />
            <label class="bl-label" [for]="'question-'+index+'-choice-'+optionIndex">
              {{ questionChoice.questionChoiceText }}
            </label>
          </div>
          }
          <span [id]="'desc-' + question.relativeOrder"
            *ngIf="!questionListResponsponse.oowQuestion[index].answer && (pageSubmitted$ | async)"
            class="bl-error-msg bl-margin-right--16">This is a required field</span>
        </div>
      </div>
    </fieldset>
    }
  </div>
  <div class="bl-font-color--base bl-no-body bl-margin-bottom--24 bl-text-align--center" *ngIf="showEmptyReportMsg">
    <div>
      <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="40" cy="40" r="40" fill="#FFF2C7" />
        <path
          d="M58.164 20.013L40.164 17.013C40.0553 16.996 39.9447 16.996 39.836 17.013L21.836 20.013C21.6023 20.0518 21.39 20.1724 21.2369 20.3531C21.0838 20.5339 20.9999 20.7631 21 21V42C21 48.058 24.256 53.612 30.414 58.06C33.2645 60.1079 36.3839 61.7527 39.684 62.948C39.889 63.0173 40.111 63.0173 40.316 62.948C43.6161 61.7527 46.7355 60.1079 49.586 58.06C55.744 53.612 59 48.058 59 42V21C59.0001 20.7631 58.9162 20.5339 58.7631 20.3531C58.61 20.1724 58.3977 20.0518 58.164 20.013Z"
          fill="#72C472"
        />
        <path
          d="M58.162 20.013L40.162 17.013C40.1074 17.0085 40.0526 17.0085 39.998 17.013V63C40.1057 62.9997 40.2128 62.9821 40.315 62.948C43.6146 61.7524 46.7336 60.1076 49.584 58.06C55.742 53.612 59 48.058 59 42V21C59 20.7628 58.9158 20.5334 58.7623 20.3526C58.6088 20.1718 58.396 20.0514 58.162 20.013Z"
          fill="#4DA34D"
        />
        <path
          d="M52.17 32.542L38.816 48.121C38.7264 48.2256 38.6162 48.3106 38.4922 48.3706C38.3682 48.4306 38.2331 48.4643 38.0955 48.4696C37.9578 48.475 37.8206 48.4518 37.6923 48.4017C37.564 48.3515 37.4475 48.2753 37.35 48.178L29.879 40.707C29.6916 40.5195 29.5862 40.2652 29.5862 40C29.5862 39.7348 29.6916 39.4805 29.879 39.293L31.293 37.879C31.4806 37.6915 31.7349 37.5862 32 37.5862C32.2652 37.5862 32.5195 37.6915 32.707 37.879L37.887 43.059L49.132 29.939C49.3047 29.7377 49.5502 29.6133 49.8147 29.593C50.0791 29.5728 50.3407 29.6584 50.542 29.831L52.061 31.131C52.1609 31.2164 52.243 31.3207 52.3025 31.4379C52.3621 31.5551 52.3979 31.6829 52.408 31.8139C52.4182 31.945 52.4024 32.0767 52.3615 32.2017C52.3207 32.3266 52.2556 32.4422 52.17 32.542Z"
          fill="white"
        />
      </svg>
    </div>
    <div class="bl-font-size--28 bl-font-weight--900 bl-font-color--black">No Verification Questions</div>
    <div class="bl-font-size--14 bl-font-color--steel bl-margin-top--16">
      It looks like {{ applicantName }} doesn’t have enough credit history to show any information here. Feel free to continue your
      application now.
    </div>
  </div>
</div>
<ecp-content-spinner [hidden]="!showSpinner"></ecp-content-spinner>
